const toggleLoadingOverlay = () => {
    const overlay = document.querySelector('#loading-overlay');
    if (overlay.classList.contains('hide')) {
        overlay.classList.remove('hide');
    } else {
        overlay.classList.add('hide');
    }
}

export default toggleLoadingOverlay;